<template>
    <section>
        <h1>
            Programa Presupuestal {{ program.code }}:
            {{ program.title }}
        </h1>
        <p>
            <img :src="program.thumb" class="ppr-icon" />
            {{ program.description }}
        </p>
    </section>
</template>
<script>
export default {
    name: "Description",
    props: {
        program: {
            type: Object,
            default: () => {}
        }
    }
}
</script>
<style scoped>
    .program .ppr-icon {
        height: 90px;
        width: auto;
        float: right;
    }
    .program h3 {
        margin-top: 1em;
        margin-bottom: 1em;
    }
    .program h3::after{
        content: none;
    }
    .program h3 button {
        color: var(--primary);
        font-weight: bold;
    }
</style>